import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=6ce22d1a"
import script from "./SearchProducts.vue?vue&type=script&lang=js"
export * from "./SearchProducts.vue?vue&type=script&lang=js"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=6ce22d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports